const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQualityAssurance(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.272,
    height: 26,
    viewBox: "0 0 21.272 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M10.636 26C4.573 24.519 0 18.422 0 11.818v-7.09L10.636 0l10.636 4.728v7.09c0 6.6-4.572 12.7-10.636 14.182zM5.212 12.515l-1.667 1.667 4.728 4.727 9.455-9.455-1.667-1.678-7.788 7.789z",
    style: {
      fill: "#002d72"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQualityAssurance);
export default __webpack_public_path__ + "static/media/QualityAssurance.35425a4adc742fd510643a58b23c2aad.svg";
export { ForwardRef as ReactComponent };